// extracted by mini-css-extract-plugin
export default {"section":"error-page_section__D+x2K","textContainer":"error-page_textContainer__Iu-mV","imageContainer":"error-page_imageContainer__r0FrG"};